/**
 * 登録の画面（/signup）が開かれたことをサーバーに 1 回だけ知らせる（2026-10-18 ops/gaps-activity・管理 10/18 Growth の広告のテスト用・
 * サーバーは apps/server/src/modules/platform/signupOpens.ts・migration 0323 signup_opens）。純関数だけ（テストは signupOpen.test.ts）。
 *
 * WHY: 広告の専用ページの「Get early access」は /signup?invite=<CODE>&src=<広告のラベル> を開く。登録した数は DB で分かるが、
 *   開いて登録しなかった数が分からない = 広告ごとの登録率が出ない。
 * 送るのは invite と src だけ（URL の他の値・Referer・入力した文字は送らない）。サーバーは生のコードを残さない（印にする）。
 * 読むのは最初に開いた時の search（AuthPage は読んだ直後に URL から invite を消す = inviteCode.ts searchWithoutInvite）。
 * 失敗は黙って捨てる（認証なしの軽い口・登録の画面を止めない）。
 */

export const SIGNUP_OPEN_PATH = '/v1/developers/signup-opens';

/** search → 送る本文。invite / src は 64 / 200 文字で切る（サーバーの上限 = それより長いと 400 で数えられないので、切って 'unknown' / 'other' にさせる） */
export function signupOpenBody(search: string): { invite: string | null; src: string | null } {
  let p: URLSearchParams;
  try {
    p = new URLSearchParams(search);
  } catch {
    return { invite: null, src: null };
  }
  const invite = p.get('invite')?.trim() || null;
  const src = p.get('src')?.trim() || null;
  return { invite: invite ? invite.slice(0, 64) : null, src: src ? src.slice(0, 200) : null };
}

/** 1 画面の読み込みにつき 1 回だけ送る関数を作る（React の StrictMode で効果が 2 回走っても 1 回） */
export function createSignupOpenReporter(send: (body: { invite: string | null; src: string | null }) => Promise<unknown>): (search: string) => void {
  let done = false;
  return (search) => {
    if (done) return;
    done = true;
    try {
      void Promise.resolve(send(signupOpenBody(search))).catch(() => undefined);
    } catch {
      // 画面を止めない
    }
  };
}
